module.exports = __webpack_public_path__ + "img/life-insurance-filled.a65aba0.png";